<div
  [class.readonly]="readonly"
  [class]="editButton === true ? 'editBttn' : ''"
>
  <label *ngIf="label" [for]="labelId">
    {{ label }} <small *ngIf="!!label && canShowRequiredLabel()">(Required)</small>
    <app-dc-popover
      *ngIf="warning"
      [type]="'warning'"
      [body]="warning"
      [class.helpText]="helpText"
    >
    </app-dc-popover>
    <app-dc-popover
      *ngIf="helpText"
      [body]="helpText"
      [class.helpText]="helpText"
    >
    </app-dc-popover>
  </label>
  <div class="position-relative">
    <!-- #select -->
    <ng-select
      #ngSelectComponent
      [labelForId]="labelId"
      [class]="
        (checkbox ? 'withCheckbox' : 'withoutCheckbox') +
        ' ' +
        (darkMode === true ? 'dark' : '') +
        ' ' +
        (clearInputX === true ? 'clearInputX' : '')
      "
      [formControl]="control"
      [items]="items"
      [multiple]="multiple"
      groupBy="category"
      bindLabel="displayValue"
      [selectableGroup]="false"
      [selectableGroupAsModel]="true"
      [closeOnSelect]="false"
      bindValue="id"
      [loading]="loading"
      [virtualScroll]="virtualScroll"
      [searchable]="searchable"
      [closeOnSelect]="closeOnSelect"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [clearSearchOnAdd]="clearSearchOnAdd"
      [addTag]="FreeText === true ? addTagFn : false"
      editButton="editButton && !control.readOnly"
      [clearOnBackspace]="true"
      [clearable]="true"
      [notFoundText]="notFoundText"
      [ngClass]="{
        'disable-arrow disable-dropdown disable-clear-all': readonly === true
      }"
      (change)="onChange($event)"
      [appendTo]="dropdownParent"
      [compareWith]="compareWith ? compareFn : null"
      (open)="onOpen(ref)"
      #ref
    >
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span class="ng-value-label" [title]="item | selectTitle">
          {{ item | selectLabel: splitLabel }}
        </span>
      </ng-template>
      <ng-template ng-header-tmp *ngIf="searchable || clearSelection">
        <input
          *ngIf="searchable == null ? false : searchable"
          class="searchInput"
          type="text"
          placeholder="Search"
          (input)="ngSelectComponent.filter($event.target.value)"
          [readonly]="readonly"
        />
        <button
          *ngIf="clearSelection"
          (click)="clearSelectionFn()"
          class="clearSelectionButton"
        >
          Clear Selection
        </button>
      </ng-template>
      <ng-template
        ng-optgroup-tmp
        let-item="item"
        let-item$="item$"
        let-index="id"
      >
        {{ item.category | uppercase }}
      </ng-template>
      <ng-template
        ng-option-tmp
        let-item="item"
        let-item$="item$"
        let-index="id"
      >
        <span [title]="item | selectTitle">
          <div
            [innerHTML]="item.displayValue"
            (click)="onOptionClicked(item)"
          ></div>
        </span>
      </ng-template>
    </ng-select>
    <button
      *ngIf="editButton && !control['readonly']"
      class="editButton btn btn-link"
      (click)="edit()"
    >
      Edit
    </button>
    <app-dc-control-validation
      *ngIf="control.touched"
      [status]="getValidationStatus()"
      class="{{
        control.hasError('required') && control.touched ? 'required' : ''
      }}"
      body="{{ customErrorMessage ? customErrorMessage + '.' + '<br/>' : '' }}{{
        control.hasError('required') ? 'Required field' + '.' + '<br/>' : ''
      }}{{ control.hasError('incorrect') ? control.errors.message + '.' : '' }}"
    ></app-dc-control-validation>
  </div>
</div>
